@switch (currentView) {
  @case(views.Home) {
    <div class="container">
      <button (click)="getUpdatesCfg(true)" class="request-button">Ver configuración de Actualizaciones</button>

      <button (click)="selectView(views.EditingCfg)" class="request-button">Modificar configuración de Actualizaciones</button>
    </div>

    <div class="container">
      <button (click)="getCheckRequests()" class="request-button">Ver Clientes</button>

      <button (click)="deleteCheckRequests()" class="request-button">Resetear Clientes</button>
    </div>

    <div class="container">
      <button (click)="getCheckRequestsErrors(); selectView(views.CheckRequestsErrors)" class="request-button">Ver Errores de clientes</button>

      <button (click)="deleteCheckRequestsErrors()" class="request-button">Resetear Errores de clientes</button>
    </div>
  }

  <!-- Vista de modificar configuración de Actualizaciones -->
  @case(views.EditingCfg) {
    <div class="edit-interval-container">
      <h4>Modificar configuración de Actualizaciones</h4>

      <input type="number" [(ngModel)]="updateCfg.segundosIntervalo" class="input-seconds" placeholder="Segundos de intervalo">

      <div class="edit-interval-buttons">
        <button class="button-colors" (click)="selectView(views.Home)">Volver</button>

        <button class="modify-button button-colors" (click)="setUpdatesCfg()"
          [disabled]="!globalService.editing || (!updateCfg.segundosIntervalo || updateCfg.segundosIntervalo <= 0)">
          Confirmar
        </button>
      </div>
    </div>
  }

  @case(views.CheckRequests) {
    <div class="search-container">
      <img (click)="showFilters = !showFilters" class="filter-icon" [src]="'assets/icons/' + (showFilters ? 'filters-close' : 'filters-open') + '.svg'"/>

      <input type="text" class="search-input" [(ngModel)]="checkRequestToSearch" (ngModelChange)="filterCheckRequests(false)" placeholder="Buscar por IP o nombre">

      <button class="back-button button button-colors" (click)="selectView(views.Home)">Volver</button>
    </div>

    <!-- Vista de clientes -->
    <div class="scroll-container">
      @if(showFilters) {
        <div class="filters-container">
          <div class="filters-row">
            <div class="filter-container">
              <p>EtrasaAPIsClients obsoleto</p>
              <select [(ngModel)]="etrasaAPIsClientsObsoletoFilter" class="filter-input">
                <option value="all">Todos</option>
                <option value="unknown">Desconocido</option>
                <option value="notObsolete">No obsoleto</option>
                <option value="obsolete">Obsoleto</option>
              </select>
            </div>

            <div class="filter-container">
              <p>Entorno</p>
              <select [(ngModel)]="entornoFilter" class="filter-input">
                @for(option of entornoFilterOptions; track option) {
                  <option [value]="option">{{option === "all" ? 'Todos' : option}}</option>
                }
              </select>
            </div>

            <div class="filter-container">
              <p>Grupo</p>
              <select [(ngModel)]="grupoFilter" class="filter-input">
                @for(option of grupoFilterOptions; track option) {
                  <option [value]="option">{{option === "all" ? 'Todos' : option}}</option>
                }
              </select>
            </div>
          </div>

          <div class="filters-row">
            <div class="filter-container">
              <p>Nombre de máquina</p>
              <input type="text" class="filter-input" [(ngModel)]="machineNameFilter" placeholder="Nombre de máquina">
            </div>

            <div class="filter-container">
              <p>Instancia</p>
              <input type="text" class="filter-input" [(ngModel)]="instanciaFilter" placeholder="Instancia">
            </div> 

            <div class="checkbox-filters-container">
              <div class="checkbox-field">
                <p>No actualizada</p>
                <input type="checkbox" [(ngModel)]="noActualizadaFilter">
              </div>

              <div class="checkbox-field">
                <p>Sin enlace</p>
                <input type="checkbox" [(ngModel)]="noUrlActualizarOraculoFilter">
              </div> 

              <div class="checkbox-field">
                <p>Sin checks online</p>
                <input type="checkbox" [(ngModel)]="noChecksOnlineFilter">
              </div> 

              <div class="checkbox-field">
                <p>Preview</p>
                <input type="checkbox" [(ngModel)]="previewFilter">
              </div> 
            </div>
          </div>

          <button class="back-button button button-colors" (click)="clearFilters()">Limpiar</button>

          <button class="back-button button button-colors" (click)="filterCheckRequests(false)">Buscar</button>
        </div>
      }

      @for(checkRequest of checkRequests; track checkRequest.titulo) {
        <div class="request" (click)="selectView(views.DetailCheckRequests, checkRequest)">
          <p class="request-title">{{checkRequest.titulo}}</p>

          <p class="request-date" [style]="getColor(checkRequest)">{{checkRequest.ultimaComprobacion | date:'dd/MM/yyyy HH:mm:ss'}}</p>

          <div class="icons-data-container">
            @if(checkRequest.preview) {
              <img class="icon-data" src="assets/icons/radar.svg"/>
            }

            @if(!!checkRequest.urlActualizarOraculo) {
              <img class="icon-data" src="assets/icons/link.svg"/>
            }
          </div>
        </div>
      }
    </div>
  }

  <!-- Detalle de petición a check -->
  @case(views.DetailCheckRequests) {
    <div class="detail-container">
      <h4>Detalles de cliente</h4>

      @if(!!selectedCheckRequest.idCliente) {
        <div class="detail-data-container">
          <label class="title-detail-data">Id de cliente:</label>
          <label class="detail-data">{{selectedCheckRequest.idCliente}}</label>
        </div>
      }

      <div class="detail-data-container">
        <label class="title-detail-data">Aplicación:</label>
        <label class="detail-data">{{selectedCheckRequest.app}}</label>
      </div>

      @if(!!selectedCheckRequest.appInfo && !!selectedCheckRequest.appInfo.version) {
        <div class="detail-data-container">
          <label class="title-detail-data">Versión:</label>
          <label class="detail-data">{{selectedCheckRequest.appInfo.version}}</label>
        </div>
      }

      <div class="detail-data-container">
        <label class="title-detail-data">Ip:</label>    
        <label class="detail-data">{{selectedCheckRequest.ip}}</label>
      </div>

      @if(!!selectedCheckRequest.appInfo && !!selectedCheckRequest.appInfo.entorno) {
        <div class="detail-data-container">
          <label class="title-detail-data">Entorno:</label>
          <label class="detail-data">{{selectedCheckRequest.appInfo.entorno}}</label>
        </div>
      }

      @if(!!selectedCheckRequest.appInfo && !!selectedCheckRequest.appInfo.machineName) {
        <div class="detail-data-container">
          <label class="title-detail-data">Nombre de máquina:</label>
          <label class="detail-data">{{selectedCheckRequest.appInfo.machineName}}</label>
        </div>
      }

      @if(!!selectedCheckRequest.appInfo && !!selectedCheckRequest.appInfo.grupo) {
        <div class="detail-data-container">
          <label class="title-detail-data">Grupo:</label>
          <label class="detail-data">{{selectedCheckRequest.appInfo.grupo}}</label>
        </div>
      }

      @if(!!selectedCheckRequest.appInfo && !!selectedCheckRequest.appInfo.instancia) {
        <div class="detail-data-container">
          <label class="title-detail-data">Instancia:</label>
          <label class="detail-data">{{selectedCheckRequest.appInfo.instancia}}</label>
        </div>
      }

      <div class="detail-data-container">
        <label class="title-detail-data">Última comprobación:</label>
        <label class="detail-data">{{selectedCheckRequest.ultimaComprobacion | date:'dd/MM/yyyy HH:mm:ss'}}</label>
      </div>

      <div class="detail-data-container">
        <label class="title-detail-data">Versión datos Oráculo:</label>
        <label class="detail-data">{{selectedCheckRequest.versionDatosOraculo | date:'dd/MM/yyyy HH:mm:ss'}}</label>
      </div>

      <div class="detail-data-container">
        <label class="title-detail-data">Actualizada:</label>
        <label class="detail-data">{{selectedCheckRequest.actualizada ? 'Sí' : 'No'}}</label>
      </div>

      @if(!!selectedCheckRequest.urlActualizarOraculo) {
        <div class="detail-data-container">
          <label class="title-detail-data">URL actualizar Oráculo:</label>
          <label class="detail-data">{{selectedCheckRequest.urlActualizarOraculo}}</label>
        </div>
      }

      <div class="detail-data-container">
        <label class="title-detail-data">EtrasaAPIsClients obsoleto:</label>
        <label class="detail-data">{{selectedCheckRequest.etrasaAPIsClientsObsoleto === true ? 'Sí' : (selectedCheckRequest.etrasaAPIsClientsObsoleto === false ? 'No' : 'Desconocido')}}</label>
      </div>

      <div class="detail-data-container">
        <label class="title-detail-data">Checks online:</label>
        <label class="detail-data">{{selectedCheckRequest.checksOnline ? 'Sí' : 'No'}}</label>
      </div>

      @if(selectedCheckRequest.preview !== undefined) {
        <div class="detail-data-container">
          <label class="title-detail-data">Preview:</label>
          <input type="checkbox" [checked]="selectedCheckRequest.preview" (click)="postCheckRequestsPreview()">
        </div>
      }

      <div class="detail-buttons">
        <button class="back-button button button-colors" (click)="selectView(views.CheckRequests)">Volver</button>

        @if(!!selectedCheckRequest.idCliente) {
          <button class="back-button button button-colors" (click)="deleteCheckRequest(selectedCheckRequest)">Eliminar</button>
        }

        @if(!!selectedCheckRequest.urlActualizarOraculo) {
          <button class="back-button button button-colors" (click)="updateOracle(selectedCheckRequest.urlActualizarOraculo)">Actualizar</button>
        }
      </div>
    </div>
  }

  @case(views.CheckRequestsErrors) {
    <div class="search-container">
      <p class="error-counter">{{checkRequestsErrors.length}}</p>

      <input type="text" class="search-input" [(ngModel)]="checkRequestErrorToSearch" (ngModelChange)="filterCheckRequestsErrors()" placeholder="Buscar por App o error">

      <button class="back-button button button-colors" (click)="selectView(views.Home)">Volver</button>
    </div>

    <!-- Vista de errores de clientes -->
    <div class="scroll-container">
      @for(checkRequestError of checkRequestsErrors; track checkRequestError.lastSeen.toString()) {
        <div class="check-request-error">
          <div class="check-request-error-row">
            <p class="check-request-error-data"><strong>App:</strong> {{checkRequestError.app ?? '- -'}}</p>

            <p class="check-request-error-data"><strong>IP:</strong> {{checkRequestError.ip ?? '- -'}}</p>
          </div>

          <div class="check-request-error-row">
            <p class="check-request-error-data"><strong>Último:</strong> {{checkRequestError.lastSeen | date:'dd/MM/yyyy HH:mm:ss'}}</p>
            
            <p class="check-request-error-data"><strong>Primero:</strong> {{!!checkRequestError.firstSeen ? (checkRequestError.firstSeen | date:'dd/MM/yyyy HH:mm:ss') : '- -'}}</p>
          </div>

          <p class="check-request-error-error"><strong>Error:</strong> {{checkRequestError.error}}</p>
        </div>
      }
    </div>
  }
}